import React from 'react';
import loadable from '@loadable/component';

import withPage from '../page';
const ConfigureAttachPage = loadable(() => import('./components'));

const loadData = async (urlParams, store, context) => {
    return Promise.resolve();
};

const ConfigureAttachContainer = props => {
    const { search } = props;
    return <ConfigureAttachPage search={search} />;
};

export default {
    component: withPage(ConfigureAttachContainer, {
        wrapperClassName: 'configure-attach-root',
        disablePageCall: true,
        showWordCloud: true,
        useV2: true,
    }),
    loadData: loadData,
};
